const id_login = {
    title: "Masuk Akun",
    password: "Kata Sandi",
    forgotpass: "Lupa Kata Sandi ?",
    submit: "Kirim",
}

export default id_login;